import Home from 'New/home'

export default Home
